const links = [
  { label: 'LinkedIn', href: 'https://linkedin.com/in/chaimae-kazoury-040715238' },
  { label: 'GitHub',   href: 'https://github.com/chaimae098' },
  { label: 'Email',    href: 'mailto:chaimaekaz05@gmail.com' },
];

export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid #1a3040', padding: '2rem 3rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem', fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#5a8a9f', position: 'relative', zIndex: 1 }}>
      <div>© 2026 Chaimae Kazoury — Portfolio YaneCode Digital - ckazoury@gmail.com</div>
      <div style={{ display: 'flex', gap: '1.5rem' }}>
        {links.map(l => (
          <a key={l.label} href={l.href} target={l.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer"
            style={{ color: '#5a8a9f', textDecoration: 'none', transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#00e5ff'}
            onMouseLeave={e => e.currentTarget.style.color = '#5a8a9f'}>
            {l.label}
          </a>
        ))}
      </div>
    </footer>
  );
}
